export const SET_LIST_PAGINATION = "SET_LIST_PAGINATION";
export const RESET_LIST_PAGINATION_PAGE = "RESET_LIST_PAGINATION_PAGE";
